export default `
  fragment ParagraphSitemapWidget on ParagraphSitemapWidget {
    id
    uuid
    entityBundle
  }
`
